<div class="container">
  <div class="wrapper">
    <div class="icon">
      <ix-icon name="block"></ix-icon>
    </div>
    <h3>{{ 'Not Allowed' | translate }}</h3>
    <p>{{ 'You do not have the permissions to access the requested information. If you think this was a mistake, please contact your system administrator.' | translate }}</p>
  </div>
  
</div>